export const WEBVIEW_TEMPLATE_IDS = ['custom', 'photo', 'video', 'video_sound', 'court', 'loading'] as const;

export type WebviewTemplateId = (typeof WEBVIEW_TEMPLATE_IDS)[number];

export type WebviewTemplateMeta = {
	slug: string | null;
	label: string;
	description: string;
	available: boolean;
};

export const WEBVIEW_TEMPLATES: Record<WebviewTemplateId, WebviewTemplateMeta> = {
	custom: {
		slug: null,
		label: 'Кастомный шаблон',
		description: 'Ваша ссылка на сайт',
		available: true,
	},
	photo: {
		slug: 'photo',
		label: 'Фото WebView',
		description: 'Страница с размытой фотографией',
		available: true,
	},
	video: {
		slug: 'video',
		label: 'Видео WebView',
		description: 'Страница с размытым видео (18+)',
		available: true,
	},
	video_sound: {
		slug: 'video-sound',
		label: 'Видео WebView со звуком',
		description: 'Видео в шапке, звук по кнопке',
		available: true,
	},
	court: {
		slug: 'court',
		label: 'Повестка в суд',
		description: 'Страница с просьбой прийти в суд',
		available: true,
	},
	loading: {
		slug: 'loading',
		label: 'Бесконечная загрузка',
		description: 'Страница с анимацией лоадера',
		available: false,
	},
};

export function isWebviewTemplateId(value: string): value is WebviewTemplateId {
	return (WEBVIEW_TEMPLATE_IDS as readonly string[]).includes(value);
}

export function isWebviewTemplateAvailable(id: WebviewTemplateId): boolean {
	return WEBVIEW_TEMPLATES[id].available;
}

export function webviewTemplatePath(slug: string): string {
	return `/webview/${slug}/`;
}

export function buildWebviewTemplateUrl(hostname: string, slug: string): string {
	return `https://${hostname}${webviewTemplatePath(slug)}`;
}
